/**
 * Fireblocks integration API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * Fireblocks vault to vault transfer request
 */
export interface VaultTransferRequest {
  /**
   * Must be the business entity of this Fireblocks service.
   */
  businessEntity: VaultTransferRequest.BusinessEntityEnum;
  /**
   * Fireblocks deposit vault to send from.
   */
  sourceVaultId: number;
  /**
   * Fireblocks deposit vault to send to.
   */
  destinationVaultId: number;
  /**
   * Fireblocks asset ID, e.g. USDT_ERC20.
   */
  fireblocksAssetName: string;
  amount: number;
  /**
   * Fireblocks user to sign the transaction.
   */
  fireblocksUserId: string;
}
export namespace VaultTransferRequest {
  export const BusinessEntityEnum = {
    Sandbox1: 'SANDBOX1',
    Sandbox2: 'SANDBOX2',
    Inc: 'INC',
    Bermuda: 'BERMUDA',
    Brazil: 'BRAZIL',
  } as const;
  export type BusinessEntityEnum = (typeof BusinessEntityEnum)[keyof typeof BusinessEntityEnum];
}
